import React from "react";
import "./Disclaimer.css";

const Disclaimer = () => {
  return (
    <>
      <div className="disclaimer-page-container">
        <h1 className="disclaimer-heading">Disclaimer</h1>
        <p className="disclaimer-text">
          These are the Terms and Conditions for the usage of this website,{" "}
          <b className="services-bold">United Investment Point</b>, and the
          related services offered by{" "}
          <b className="services-bold">United Investment Point</b> (hereafter
          referred to as "Related Services"). "Related Services" include but are
          not limited to Stock Market Trading, Mutual Funds, ULIPs, Investment
          Recommendations, and Analysis provided through email, messaging
          platforms, mobile phone, SMS, telephone, or any other form, manner, or
          media.
        </p>
        <p className="disclaimer-text">
          <b className="services-bold">United Investment Point</b> owns and
          operates <b>uip.net.in</b> along with all its content and related
          services. By accessing and using this website, you agree to the Terms
          and Conditions outlined below. Furthermore, you acknowledge that{" "}
          <b className="services-bold">United Investment Point</b> reserves the
          right to modify or alter these Terms and Conditions at any time
          without prior notice or liability.
        </p>
        <h2 className="disclaimer-subheading">Use of Content</h2>
        <p className="disclaimer-text">
          The information and materials available on this website and related
          services are for informational purposes only and reflect the personal
          views of the contributors. While the content may provide analysis,
          recommendations, or suggestions, users are advised to exercise their
          judgment and seek professional advice before making investment
          decisions.
        </p>
        <p className="disclaimer-text">
          <b className="services-bold">United Investment Point</b> makes no
          guarantees regarding the timeliness, accuracy, or quality of the
          information provided. The investments or trades discussed or
          recommended through this website or related services may not be
          suitable for all investors.
        </p>
        <h2 className="disclaimer-subheading">Intellectual Property</h2>
        <p className="disclaimer-text">
          The content of this website and related services may not be copied,
          reproduced, republished, uploaded, posted, transmitted, or distributed
          for any non-personal use without prior written permission from{" "}
          <b className="services-bold">United Investment Point</b>. Users
          intending to utilize the services provided by{" "}
          <b className="services-bold">United Investment Point</b> should do so
          only after thoroughly considering the information provided, along with
          other relevant factors.
        </p>
        <h2 className="disclaimer-subheading">Liability</h2>
        <p className="disclaimer-text">
          <b className="services-bold">United Investment Point</b> shall not be
          held responsible for any losses or profits arising from decisions made
          based on the analysis or recommendations provided through the website
          or related services. Users bear full responsibility for their
          decisions and actions.
        </p>
        <h2 className="disclaimer-subheading">Linked Websites</h2>
        <p className="disclaimer-text">
          This website may contain links to third-party websites.{" "}
          <b className="services-bold">United Investment Point</b> is not
          responsible for the content of any linked sites and does not endorse
          or recommend any information, products, or services offered on those
          websites. Access to third-party websites is at the user’s own
          discretion and risk.
        </p>
        <h2 className="disclaimer-subheading">Agreement to Terms</h2>
        <p className="disclaimer-text">
          By continuing to use this website and related services, you confirm
          your agreement to these Terms and Conditions. If you disagree with any
          of the terms outlined in this agreement, you are advised to
          discontinue the use of the website and its related services
          immediately.
        </p>
        <h3 className="disclaimer-contact-heading">For Further Information</h3>
        <p className="disclaimer-text">Please contact us at:</p>
        <ul className="disclaimer-contact-list">
          <li>
            <b>Phone:</b> <a href="tel:9415762826">+91 9415762826</a>
          </li>
          <li>
            <b>Email:</b>{" "}
            <a href="mailto:awasthi.manjul@gmail.com">
              awasthi.manjul@gmail.com
            </a>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Disclaimer;
